import { ReactNode } from 'react';
import { cn } from '@ecom/helper-react-class-combine';

export const FormSubmitError = ({
  message,
  className,
}: {
  message: ReactNode;
  className?: string;
}) => {
  return <p className={cn('text-error mt-2 mb-2 text-center', className)}>{message}</p>;
};
